import { render, staticRenderFns } from "./LeagueConfiguration.vue?vue&type=template&id=e5a2303e"
import script from "./LeagueConfiguration.vue?vue&type=script&lang=js"
export * from "./LeagueConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports